const moment = require('moment');
const { isEmpty } = require('lodash');
const Constants = require('./constants');

function IsArray(obj) {
  if (Array.isArray(obj)) {
    return true;
  }
  return false;
}

function IsEmpty(obj) {
  if (obj === null || obj === undefined || typeof obj === 'undefined' || obj === '' || obj === 'undefined') {
    return true;
  } else if (Array.isArray(obj) && obj.length === 0) {
    return true;
  } else {
    return false;
  }
}

function IsNull(obj) {
  if (obj === null || obj === undefined || typeof obj === 'undefined' || obj === '' || obj === 'undefined' || obj === 'null') {
    return true;
  } else {
    return false;
  }
}

function IsObject(obj) {
  return typeof obj === 'object' && !IsArray(obj) && obj !== null;
}

function isValidUrl(obj) {
  if (obj.indexOf('http://') === 0 || obj.indexOf('https://') === 0) {
    return true;
  } else if (isEmpty(obj)) {
    return true;
  } else {
    return false;
  }
}

function IsValidWwwAndHttpUrl(obj) {
  if (!IsEmpty(obj) && (obj.indexOf('www.') === 0 || obj.indexOf('http://') === 0)) {
    return true;
  } else {
    return false;
  }
}

function IsValidHexColor(hexCode) {
  // Define the regular expression pattern for 3-character or 6-character hex color code
  const hexColorPattern = /^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$/;
  return hexColorPattern.test(hexCode);
}

/**
 * Check if link is a valid https url
 * @param {String} url url to check
 * @returns {Boolean} true if link is a valid https url, false otherwise
 */
function IsValidHttpsUrl(url) {
  if (!url.startsWith('https://')) return false;

  const httpsRegex = /(https:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
  const match = url.match(httpsRegex);

  return match ? (match[0] === url) : false;
}

function IsNumber(obj) {
  if (typeof obj === 'number' && !isNaN(obj)) {
    return true;
  } else {
    return false;
  }
}

// validate map coordinates (latitude and longitude)
function IsMapCoordValid(lat, lng) {
  if (IsEmpty(lat) || IsEmpty(lng)) {
    return false;
  }

  const latNum = Number(lat);
  const lngNum = Number(lng);

  if (!IsNumber(latNum) || !IsNumber(lngNum)) {
    return false;
  }

  return latNum >= -90 && latNum <= 90 && lngNum >= -180 && lngNum <= 180;
}

function IsString(obj) {
  if (typeof obj === 'string') {
    return true;
  }
  return false;
}

function IsTrue(obj) {
  if (obj === true || obj === 'true') {
    return true;
  } else {
    return false;
  }
}

function IsFunction(obj) {
  return typeof obj === 'function' ? obj() : obj;
}

function IsMultipleUrl(obj) {
  const urls = obj.split('\n');
  return (urls.length > 1 && urls[1].trim().length > 0);
}

function IfEmptyThrowError(obj, errorMsg) {
  if (IsEmpty(obj)) {
    throw new Error(errorMsg);
  }
}

function IfFalseThrowError(flag, errorMsg) {
  if (flag === false) {
    throw new Error(errorMsg);
  }
}

function IfNotEmptyThrowError(responseError, errorMsg) {
  if (!IsEmpty(responseError)) {
    throw new Error(errorMsg);
  }
}

function IfNullThrowError(responseError, errorMsg) {
  if (IsNull(responseError)) {
    throw new Error(errorMsg);
  }
}

function IfTrueThrowError(flag, errorMsg) {
  if (flag === true) {
    throw new Error(errorMsg);
  }
}

function IfMapCoordInvalidThrowError(latitude, longitude) {
  const isLatEmpty = IsEmpty(latitude);
  const isLngEmpty = IsEmpty(longitude);

  IfTrueThrowError(
    isLatEmpty !== isLngEmpty,
    Constants.Error.MapCoordBothOrNone,
  );

  if (!isLatEmpty) {
    IfFalseThrowError(
      IsMapCoordValid(latitude, longitude),
      Constants.Error.MapCoordInvalid,
    );
  }
}

function ImageFileTypeIsValid(file) {
  if (file && file.mimetype !== 'image/png'
    && file.mimetype !== 'image/jpg'
    && file.mimetype !== 'image/jpeg'
  ) {
    return false;
  }
  return true;
}

function VideoFileTypeIsValid(file) {
  if (file && file.mimetype !== 'video/mp4') {
    return false;
  }
  return true;
}

function IsDateRangeOverlap(startDateA, endDateA, startDateB, endDateB) {
  // check for "empty" times
  if (IsEmpty(startDateA) || IsEmpty(endDateA)) {
    throw new Error('Both startDateA and endDateA are required');
  } else if (IsEmpty(startDateB) || IsEmpty(endDateB)) {
    throw new Error('Both startDateB and endDateB are required');
  }

  // convert time strings to Moment.js objects
  const startA = moment(startDateA, 'YYYY-MM-DD');
  const endA = moment(endDateA, 'YYYY-MM-DD');
  const startB = moment(startDateB, 'YYYY-MM-DD');
  const endB = moment(endDateB, 'YYYY-MM-DD');

  // check for overlap
  return startA.isSameOrBefore(endB) && endA.isSameOrAfter(startB);
}

function IsTimePeriodOverlap(startTimeA, endTimeA, startTimeB, endTimeB) {
  // check for "empty" times
  if (IsEmpty(startTimeA) || IsEmpty(endTimeA)) {
    throw new Error('Both startTimeA and endTimeA are required');
  } else if (IsEmpty(startTimeB) || IsEmpty(endTimeB)) {
    throw new Error('Both startTimeB and endTimeB are required');
  }

  // convert time strings to Moment.js objects
  const startA = moment(startTimeA, 'HH:mm:ssZ');
  const endA = moment(endTimeA, 'HH:mm:ssZ');
  const startB = moment(startTimeB, 'HH:mm:ssZ');
  const endB = moment(endTimeB, 'HH:mm:ssZ');

  // check for overlap
  return startA.isSameOrBefore(endB) && endA.isSameOrAfter(startB);
}

module.exports = {
  IsArray,
  IsEmpty,
  isValidUrl,
  IsValidWwwAndHttpUrl,
  IsValidHttpsUrl,
  IsValidHexColor,
  IsNumber,
  IsString,
  IsTrue,
  IsObject,
  IsFunction,
  IsMultipleUrl,
  IsDateRangeOverlap,
  IsTimePeriodOverlap,
  IfEmptyThrowError,
  IfFalseThrowError,
  IfNotEmptyThrowError,
  IfNullThrowError,
  IfTrueThrowError,
  IsMapCoordValid,
  IfMapCoordInvalidThrowError,
  ImageFileTypeIsValid,
  VideoFileTypeIsValid,
};
